import DropDownJuridique from "../components/Card/DropDownJuridique";
import { Helmet } from 'react-helmet';

const FormJuridic = () => {
  return (
    <>
      <Helmet>
        <title>Forme juridique - Trouvez le statut idéal pour votre entreprise | FB Conseils</title>
        <meta name="description" content="Comparez les formes juridiques : SAS, SARL, EI, micro-entreprise. Découvrez le statut le plus adapté à votre projet de création d'entreprise." />
        <link rel="canonical" href="https://maformejuridique.fr/juridique" />
        <meta property="og:title" content="Forme juridique - Quel statut pour votre entreprise ?" />
        <meta property="og:description" content="Comparez SAS, SARL, EI et micro-entreprise. Trouvez le statut idéal pour votre projet." />
        <meta property="og:url" content="https://maformejuridique.fr/juridique" />
      </Helmet>
      <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #f8fffe 0%, #eef7f5 40%, #f0f9f7 100%)' }}>
        <DropDownJuridique />
      </div>
    </>
  );
};

export default FormJuridic;